/**
 * V-227. What a live-map driver marker's popup says, split out of
 * LiveMap.jsx so it can be tested without a Leaflet canvas — the same
 * reasoning routeTrail.js already applies to OrderRouteMap.jsx.
 */

import { escapeHtml, relativeTime } from '@/lib/format';

/** A driver marker's popup: name, the truck they're CURRENTLY on, order
 *  status, and how long ago the fix arrived.
 *
 *  `license_plate`, not `vehicle_plate` — blueprints/drivers.py's
 *  list_drivers() (V-225) returns both: `vehicle_plate` stays the
 *  driver's own raw, possibly-stale fallback field, and `license_plate`
 *  is the resolved one, whatever vehicle they're actually assigned to in
 *  Transportas. A dispatcher clicking a live pin wants the truck that
 *  driver is on right now, not whatever was last typed on the driver
 *  form.
 *
 *  `full_name`/`license_plate` go through escapeHtml() — this string is
 *  handed straight to Leaflet's bindPopup/setPopupContent, which set it
 *  via innerHTML — see escapeHtml()'s own docstring. The two `t(...)`
 *  calls need no escaping: their output comes from this app's own i18n
 *  catalog, not a database row. */
export function driverPopupHtml(d, t) {
  return [
    `<strong>${escapeHtml(d.full_name)}</strong>`,
    escapeHtml(d.license_plate),
    `${t('dispatcher.orderStatus')}: ${t(`status.driver.${d.status ?? 'idle'}`)}`,
    relativeTime(d.last_ping_at, t),
  ]
    .filter(Boolean)
    .join('<br>');
}
